// extracted by mini-css-extract-plugin
export default {"wrapper":"LiveEnded_wrapper__zhICE","title":"LiveEnded_title__5EDO2","text":"LiveEnded_text__StAay","actions":"LiveEnded_actions__Oi7DE","button":"LiveEnded_button__yrWQD"};